import axios, { AxiosError } from "axios"
import Constants from "./Constants"
import APIError, { ErrorType } from "./errors/APIError"
import Wochenbrief from "./model/Wochenbrief"

class WochenbriefAPI {
  public async currentLetter(): Promise<Wochenbrief> {
    try {
      const response = await axios.get(`${Constants.CoreHost}/newsboard/kzo/monthly-letter`)
      if (response.status !== 200 || !response.data?.content) {
        throw new Error(response.data?.message)
      }
      return response.data as Wochenbrief
    } catch (error: any) {
      throw new APIError(ErrorType.LoadingFailed, (error as AxiosError).message)
    }
  }
}

export default WochenbriefAPI
